import { IMAGES } from "./siteData";

export const Method = () => (
  <section id="sound-design" data-testid="method-section" className="py-24 px-6 border-b border-[#1e2335] bg-[#0c0e17]">
    <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-5 space-y-6">
        <span className="text-xs font-mono-code text-[#818cf8] uppercase tracking-widest">SINESTESIA: SUONO &amp; GRAFICA</span>
        <h2 className="text-3xl md:text-4xl font-disp font-bold text-white">Compositore con Visione Visiva</h2>
        <p className="font-serif-body text-[#94a3b8] leading-relaxed">
          La laurea in Graphic Design plasma un approccio unico: la colonna sonora non &egrave; solo musica di
          sottofondo, ma una struttura architetturale sincronizzata con la fotografia e il ritmo di montaggio del
          regista.
        </p>

        <div className="space-y-4 pt-2">
          <div className="p-4 rounded-xl bg-[#111320] border border-[#212638] flex items-start gap-4">
            <div className="p-2 rounded bg-indigo-500/10 text-indigo-400 mt-1">
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
              </svg>
            </div>
            <div>
              <h4 className="font-disp font-bold text-white text-sm">Design Acustico Sartoriale</h4>
              <p className="text-xs text-[#94a3b8] font-serif-body">Ogni opera riceve un vocabolario di synth creato da zero.</p>
            </div>
          </div>

          <div className="p-4 rounded-xl bg-[#111320] border border-[#212638] flex items-start gap-4">
            <div className="p-2 rounded bg-purple-500/10 text-purple-400 mt-1">
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1zM4 22v-7" />
              </svg>
            </div>
            <div>
              <h4 className="font-disp font-bold text-white text-sm">Sincronia Frame per Frame</h4>
              <p className="text-xs text-[#94a3b8] font-serif-body">Accenti ritmici modellati sui cambi di inquadratura.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="lg:col-span-7">
        <div className="rounded-2xl overflow-hidden border border-[#2a3048] aspect-[16/10] relative flex flex-col justify-between">
          <img
            src={IMAGES.methodFrame}
            alt="Postazione di sound design con monitor da studio e tastiere synth"
            className="absolute inset-0 w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#070810] via-[#070810]/45 to-[#070810]/20"></div>

          <div className="relative z-10 flex items-center justify-between text-xs font-mono-code text-[#c7d2fe] p-8 pb-0">
            <span>MODALIT&Agrave; LAVORO: SCRIPT TO SCORE</span>
            <span>96 KHZ WORKFLOW</span>
          </div>

          <div className="relative z-10 my-auto px-8 space-y-2 py-4">
            <div className="h-1 bg-indigo-500/30 rounded-full overflow-hidden">
              <div className="h-full bg-gradient-to-r from-indigo-500 to-purple-500 w-3/4"></div>
            </div>
            <div className="flex justify-between text-[11px] font-mono-code text-[#a5b4fc]">
              <span>PRE-PRODUZIONE &amp; THEME DISCOVERY</span>
              <span>FINAL MASTER</span>
            </div>
          </div>

          <div className="relative z-10 m-8 mt-0 bg-black/50 backdrop-blur-sm p-4 rounded-xl border border-white/5 text-xs text-[#cbd5e1] font-mono-code flex justify-between items-center">
            <span>DISPONIBILE PER PROGETTI INDIPENDENTI</span>
            <span className="text-emerald-400">CALENDARIO APERTO</span>
          </div>
        </div>
      </div>
    </div>
  </section>
);
